import { firebase_auth } from "./Fire_Base_API";
import firebase from "firebase/app";

/**
 * auth google API class
 * @class auth_Google_API
 */
export default class auth_API {
  /**
   * call auth.
   *
   * @static
   * @memberof auth_API
   */
  static login(auth_way) {
    switch (auth_way) {
      case "google":
        this.login_with(new firebase.auth.GoogleAuthProvider());
        break;

      default:
        break;
    }
  }

  /**
   * logout
   *
   * @static
   * @memberof auth_API
   */
  static logout() {
    firebase_auth
      .signOut()
      .then(function() {})
      .catch(function() {});
  }

  /**
   * get current login user info
   *
   * @static
   * @returns login: user Object user_info
   * @memberof auth_API
   */
  static get_Login_Status() {
    return new Promise((resolve, reject) => {
      firebase_auth.onAuthStateChanged(function(user) {
        if (user) {
          resolve(user);
        } else {
          reject(null);
        }
      });
    });
  }
}
